module.exports = __webpack_public_path__ + "img/bg2.61e491d0.jpg";